"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function isQueryOptionsObject(options) {
    return options && typeof options === 'object' && options.queryOptionsType !== undefined;
}
exports.default = isQueryOptionsObject;
//# sourceMappingURL=isQueryOptionsObject.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@kurtosys/ksys-app-template/dist/utils/isQueryOptionsObject.js
// module id = 355
// module chunks = 1